import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e7d5d83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white-50 p-4" }
const _hoisted_2 = { class: "mx-4" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "col-form-label fs-9 fw-bold" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "border-bottom-search" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = ["placeholder", "maxlength"]
const _hoisted_11 = { class: "border-bottom-search" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_14 = { class: "col-lg-8 d-lg-flex align-items-center fs-7" }
const _hoisted_15 = { class: "input-group mb-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-lg-3 d-flex align-items-center pb-2" }, "～", -1))
const _hoisted_18 = { class: "input-group mb-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_20 = { class: "border-bottom-search" }
const _hoisted_21 = { class: "row fs-7" }
const _hoisted_22 = { class: "col-lg-2 col-form-label" }
const _hoisted_23 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_24 = { class: "col-lg-12" }
const _hoisted_25 = ["placeholder", "maxlength"]
const _hoisted_26 = {
  key: 0,
  class: "border-bottom-search"
}
const _hoisted_27 = { class: "row align-items-center fs-7" }
const _hoisted_28 = { class: "col-lg-2 col-form-label" }
const _hoisted_29 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_30 = { class: "col-lg-4" }
const _hoisted_31 = { value: "" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 1,
  class: "border-bottom-search"
}
const _hoisted_34 = { class: "row fs-7" }
const _hoisted_35 = { class: "col-lg-2 col-form-label" }
const _hoisted_36 = { class: "col-lg-9" }
const _hoisted_37 = { class: "row mb-3" }
const _hoisted_38 = { class: "col-lg-2 col-form-label" }
const _hoisted_39 = { class: "col-lg-10" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-7" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "row mb-3" }
const _hoisted_44 = { class: "col-lg-2 col-form-label" }
const _hoisted_45 = { class: "col-lg-10" }
const _hoisted_46 = { class: "d-lg-flex gap-3 mb-3" }
const _hoisted_47 = { class: "col-lg-1 fs-7 col-form-label" }
const _hoisted_48 = { class: "col-lg-6" }
const _hoisted_49 = { value: "" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "d-lg-flex gap-3" }
const _hoisted_52 = { class: "col-lg-1 fs-7 col-form-label" }
const _hoisted_53 = { class: "col-lg-6" }
const _hoisted_54 = { value: "" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-lg-2 col-form-label" }
const _hoisted_58 = { class: "col-lg-10" }
const _hoisted_59 = { class: "d-lg-flex gap-3 align-items-center" }
const _hoisted_60 = { class: "col-lg-4" }
const _hoisted_61 = {
  class: /*#__PURE__*/_normalizeClass(['input-group mb-2 mb-lg-0'])
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_63 = { class: "border-bottom-search" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_66 = { class: "col-lg-9" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_69 = { class: "col-lg-10" }
const _hoisted_70 = { class: "d-lg-flex gap-3" }
const _hoisted_71 = { class: "col-lg-4" }
const _hoisted_72 = ["placeholder", "maxlength"]
const _hoisted_73 = { class: "col-lg-1 text-end fs-7 col-form-label" }
const _hoisted_74 = { class: "col-lg-4" }
const _hoisted_75 = ["placeholder", "maxlength"]
const _hoisted_76 = {
  key: 0,
  class: "accordion accordion-flush px-0",
  id: "accordionFlushExample"
}
const _hoisted_77 = { class: "accordion-item bg-custom" }
const _hoisted_78 = {
  class: "accordion-header",
  id: "flush-headingOne"
}
const _hoisted_79 = ["data-bs-target", "aria-controls"]
const _hoisted_80 = ["id"]
const _hoisted_81 = { class: "border-bottom-search" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_84 = { class: "col-lg-9" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_87 = { class: "col-lg-10" }
const _hoisted_88 = { class: "d-lg-flex gap-3" }
const _hoisted_89 = { class: "col-lg-4" }
const _hoisted_90 = ["placeholder", "maxlength"]
const _hoisted_91 = { class: "col-lg-1 text-end fs-7 col-form-label" }
const _hoisted_92 = { class: "col-lg-4" }
const _hoisted_93 = ["placeholder", "maxlength"]
const _hoisted_94 = { class: "border-bottom-search" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_97 = { class: "col-lg-9" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_100 = { class: "col-lg-10" }
const _hoisted_101 = { class: "d-lg-flex gap-3 mb-3" }
const _hoisted_102 = { class: "col-lg-1 fs-7 col-form-label" }
const _hoisted_103 = { class: "col-lg-6" }
const _hoisted_104 = { value: "" }
const _hoisted_105 = ["value"]
const _hoisted_106 = { class: "d-lg-flex gap-3" }
const _hoisted_107 = { class: "col-lg-1 fs-7 col-form-label" }
const _hoisted_108 = { class: "col-lg-6" }
const _hoisted_109 = { value: "" }
const _hoisted_110 = ["value"]
const _hoisted_111 = { class: "border-bottom-search" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_114 = { class: "col-lg-9" }
const _hoisted_115 = { class: "row align-items-center" }
const _hoisted_116 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_117 = { class: "col-lg-10" }
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-lg-7" }
const _hoisted_120 = ["placeholder", "maxlength"]
const _hoisted_121 = { class: "border-bottom-search" }
const _hoisted_122 = { class: "row" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_124 = { class: "col-lg-9" }
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_127 = { class: "col-lg-10" }
const _hoisted_128 = { class: "row" }
const _hoisted_129 = { class: "col-lg-7" }
const _hoisted_130 = { class: "d-lg-flex align-items-center" }
const _hoisted_131 = {
  class: /*#__PURE__*/_normalizeClass(['input-group mb-2 mb-lg-0'])
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 fs-7 col-form-label px-0 text-align-center pb-2" }, /*#__PURE__*/_toDisplayString('～'), -1))
const _hoisted_134 = {
  class: /*#__PURE__*/_normalizeClass(['input-group mb-2 mb-lg-0'])
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_136 = { class: "mb-4 border-bottom-search" }
const _hoisted_137 = { class: "row" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_139 = { class: "col-lg-9" }
const _hoisted_140 = { class: "row align-items-center" }
const _hoisted_141 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_142 = { class: "col-lg-10" }
const _hoisted_143 = { class: "row" }
const _hoisted_144 = { class: "col-lg-7" }
const _hoisted_145 = ["placeholder", "maxlength"]
const _hoisted_146 = {
  key: 1,
  class: "border-bottom-search"
}
const _hoisted_147 = { class: "row align-items-center" }
const _hoisted_148 = { class: "col-lg-2 fs-7" }
const _hoisted_149 = { class: "col-lg-9" }
const _hoisted_150 = { class: "row" }
const _hoisted_151 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_152 = { class: "col-lg-10" }
const _hoisted_153 = { class: "d-lg-flex align-items-center gap-3" }
const _hoisted_154 = { class: "col-lg-4" }
const _hoisted_155 = ["placeholder", "maxlength"]
const _hoisted_156 = { class: "col-lg-1 text-end fs-7 col-form-label" }
const _hoisted_157 = { class: "col-lg-4" }
const _hoisted_158 = ["placeholder", "maxlength"]
const _hoisted_159 = {
  key: 2,
  class: "border-bottom-search"
}
const _hoisted_160 = { class: "row" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_162 = { class: "col-lg-9" }
const _hoisted_163 = { class: "row" }
const _hoisted_164 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_165 = { class: "col-lg-10" }
const _hoisted_166 = { class: "row align-items-center" }
const _hoisted_167 = { class: "col-lg-7" }
const _hoisted_168 = ["placeholder", "maxlength"]
const _hoisted_169 = {
  key: 3,
  class: "accordion accordion-flush px-0",
  id: "accordionFlushExample1"
}
const _hoisted_170 = { class: "accordion-item bg-custom" }
const _hoisted_171 = {
  class: "accordion-header",
  id: "flush-headingOne"
}
const _hoisted_172 = ["data-bs-target", "aria-controls"]
const _hoisted_173 = ["id"]
const _hoisted_174 = {
  key: 0,
  class: "align-items-center d-flex justify-content-center m-0 mb-4 mb-lg-5 mt-5 p-0 tab-header-custom"
}
const _hoisted_175 = ["onClick"]
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down fs-6" })
], -1))
const _hoisted_177 = {
  key: 1,
  class: "border-bottom-search"
}
const _hoisted_178 = { class: "row" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7" }, null, -1))
const _hoisted_180 = { class: "col-lg-9" }
const _hoisted_181 = { class: "row" }
const _hoisted_182 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_183 = { class: "col-lg-10" }
const _hoisted_184 = { class: "row" }
const _hoisted_185 = { class: "col-lg-7" }
const _hoisted_186 = ["placeholder", "maxlength"]
const _hoisted_187 = {
  key: 2,
  class: "border-bottom-search"
}
const _hoisted_188 = { class: "row" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7" }, null, -1))
const _hoisted_190 = { class: "col-lg-9" }
const _hoisted_191 = { class: "row" }
const _hoisted_192 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_193 = { class: "col-lg-10" }
const _hoisted_194 = { class: "row" }
const _hoisted_195 = { class: "col-lg-7" }
const _hoisted_196 = ["placeholder", "maxlength"]
const _hoisted_197 = {
  key: 3,
  class: "border-bottom-search"
}
const _hoisted_198 = { class: "row" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 col-form-label fs-7" }, null, -1))
const _hoisted_200 = { class: "col-lg-9" }
const _hoisted_201 = { class: "row align-items-center" }
const _hoisted_202 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_203 = { class: "col-lg-10" }
const _hoisted_204 = { class: "row" }
const _hoisted_205 = { class: "col-lg-7" }
const _hoisted_206 = { class: "d-lg-flex align-items-center fs-7" }
const _hoisted_207 = { class: "input-group mb-2 mb-lg-0" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-lg-3 d-flex align-items-center pb-2 pb-lg-0" }, "～", -1))
const _hoisted_210 = { class: "input-group mb-2 mb-lg-0" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_212 = {
  key: 4,
  class: "border-bottom-search"
}
const _hoisted_213 = { class: "row" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7 word-wrapper" }, null, -1))
const _hoisted_215 = { class: "col-lg-9" }
const _hoisted_216 = { class: "row" }
const _hoisted_217 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_218 = { class: "col-lg-10" }
const _hoisted_219 = { class: "row" }
const _hoisted_220 = { class: "col-lg-7" }
const _hoisted_221 = ["placeholder", "maxlength"]
const _hoisted_222 = {
  key: 5,
  class: "border-bottom-search"
}
const _hoisted_223 = { class: "row" }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7 word-wrapper" }, null, -1))
const _hoisted_225 = { class: "col-lg-9" }
const _hoisted_226 = { class: "row" }
const _hoisted_227 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_228 = { class: "col-lg-10" }
const _hoisted_229 = { class: "row" }
const _hoisted_230 = { class: "col-lg-7" }
const _hoisted_231 = ["placeholder", "maxlength"]
const _hoisted_232 = {
  key: 6,
  class: "border-bottom-search"
}
const _hoisted_233 = { class: "row" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7 word-wrapper" }, null, -1))
const _hoisted_235 = { class: "col-lg-9" }
const _hoisted_236 = { class: "row" }
const _hoisted_237 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_238 = { class: "col-lg-10" }
const _hoisted_239 = { class: "row" }
const _hoisted_240 = { class: "col-lg-7" }
const _hoisted_241 = ["placeholder", "maxlength"]
const _hoisted_242 = {
  key: 7,
  class: "border-bottom-search"
}
const _hoisted_243 = { class: "row" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7 word-wrapper" }, null, -1))
const _hoisted_245 = { class: "col-lg-9" }
const _hoisted_246 = { class: "row" }
const _hoisted_247 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_248 = { class: "col-lg-10" }
const _hoisted_249 = { class: "row" }
const _hoisted_250 = { class: "col-lg-7" }
const _hoisted_251 = ["placeholder", "maxlength"]
const _hoisted_252 = {
  key: 8,
  class: "border-bottom-search"
}
const _hoisted_253 = { class: "row" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7 word-wrapper" }, null, -1))
const _hoisted_255 = { class: "col-lg-9" }
const _hoisted_256 = { class: "row" }
const _hoisted_257 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_258 = { class: "col-lg-10" }
const _hoisted_259 = { class: "row" }
const _hoisted_260 = { class: "col-lg-7" }
const _hoisted_261 = ["placeholder", "maxlength"]
const _hoisted_262 = { class: "border-bottom-search" }
const _hoisted_263 = { class: "row" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fs-7 word-wrapper" }, null, -1))
const _hoisted_265 = { class: "col-lg-9" }
const _hoisted_266 = { class: "row" }
const _hoisted_267 = { class: "col-lg-2 fs-7 col-form-label" }
const _hoisted_268 = { class: "col-lg-10" }
const _hoisted_269 = { class: "col-lg-7" }
const _hoisted_270 = { class: "col-3 form-check me-5" }
const _hoisted_271 = ["for"]
const _hoisted_272 = ["id", "value"]

import { ref, watch, onMounted, computed, watchEffect, nextTick } from 'vue'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import flatPickr from 'vue-flatpickr-component'
import {
  MAX_LENGTH_EMAIL,
  MAX_LENGTH_ADDITIONAL_INFORMATION,
  MAX_LENGTH_PERSONAL_TITLE_SEARCH,
  MAX_LENGTH_CONTENT_SEARCH,
  MAX_LENGTH_WORK_POSITION_SEARCH,
  MAX_LENGTH_WORK_DEPARTMENT_SEARCH,
  MAX_LENGTH_USER_ID_LIST_SEARCH,
  MAX_ADDITIONAL_INFORMATION_LENGTH,
} from '@/constants/number'
import { translate } from '@/languages/i18n'
import dayjs from 'dayjs'
import { CONVERSATIONS_STORE, REGISTER_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { PREFECTURES } from '@/constants/index'
import { useRoute } from 'vue-router'
import { ALUMNI_REGISTER_FORM_STORE } from '@/store/constants'
import { yearDropdownPlugin } from '@/constants/yearDropdownPlugin'
import { configYM } from '@/constants/datepicker'
import { FORM_TYPE, SEARCH_METHODS } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  resetDataDetail: {
    type: Boolean,
  },
  tabInfo: Boolean,
  filterForAlumni: {
    type: Boolean,
    default: false,
  },
},
  emits: ['formDetail'],
  setup(__props, { emit }) {

const props = __props

const dataSearchDetail = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_DATA_SEARCH_DETAIL])
const listJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])
const historyListJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])
const subJob = ref([])
const historySubJob = ref([])


const store = useStore()

onMounted(() => {
  if (Object.keys(dataSearchDetail.value.info).length > 0) {
    InfoData.value = dataSearchDetail.value.info
  }
  store.dispatch(REGISTER_STORE.ACTIONS.SET_LIST_JOBS)
})

watch(
  () => props.resetDataDetail,
  () => {
    if (props.resetDataDetail) {
      InfoData.value.dob_start = ''
      InfoData.value.dob_end = ''
      InfoData.value.email = ''
      InfoData.value.personalTitle = ''
      InfoData.value.personalContents = ''
      InfoData.value.workPosition = ''
      InfoData.value.workDepartment = ''
      InfoData.value.workContents = ''
      InfoData.value.management_no = ''
      InfoData.value.address = ''
      InfoData.value.additionalInformation1 = ''
      InfoData.value.additionalInformation2 = ''
      InfoData.value.additionalInformation3 = ''
      InfoData.value.additionalInformation4 = ''
      InfoData.value.additionalInformation5 = ''
      InfoData.value.institution = ''
      InfoData.value.jobTypeParentId = ''
      InfoData.value.jobTypeChildId = ''
      InfoData.value.enrollmentStartPeriod = ''
      InfoData.value.corporationEndPeriod = ''
      InfoData.value.corporationStartPeriod = ''
      InfoData.value.portfolioWorkHistoryCorporationName = ''
      InfoData.value.historyJobTypeParentId = ''
      InfoData.value.historyJobTypeChildId = ''
      InfoData.value.startPeriod = ''
      InfoData.value.endPeriod = ''
      InfoData.value.corporationOrganizationName = ''
      InfoData.value.corporationDepartmentName = ''
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'info', data: InfoData.value })
    }
  }
)

watch(
  () => props.tabInfo,
  () => {
    if (props.tabInfo) {
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'info', data: InfoData.value })
      const management_no_new = parseStringToArray(InfoData.value.management_no)
      emit('formDetail', { ...InfoData.value, management_no: management_no_new, form_type: getFormType(activeTab.value) })
    }
  }
)
watchEffect(() => {
  if (listJobs?.value?.length > 0) {
    subJob.value = listJobs?.value?.find((e: any) => e.id === InfoData?.value?.jobTypeParentId)?.child
  }
  if (historyListJobs?.value?.length > 0) {
    historySubJob.value = historyListJobs?.value?.find((e: any) => e.id === InfoData?.value?.historyJobTypeParentId)?.child
  }
})
const initialDate = computed(() => {
  // Get the current year, subtract 30 years, and set to January 1st
  const yearThirtyYearsAgo = dayjs().year() - 30
  return dayjs(new Date(yearThirtyYearsAgo, 0, 1)).format('YYYY-MM-DD')
})
const configDateSearch = {
  disableMobile: true,
  locale: Japanese,
  wrap: true,
  minDate: '1900-01', // 1900年まで選択できる（固定。バリデーションに合わせる。）
  maxDate: Date.now(), // 未来日が選択できない
  defaultClearDate: initialDate.value,
  dateFormat: 'Y/m/d',

  onReady: function (selectedDates, dateStr, instance) {
    instance.jumpToDate(new Date(initialDate.value))
  },

  plugins: [
    yearDropdownPlugin({
      yearStart: 1900,
      yearEnd: 0,
      fixedStartYear: true,
      date: new Date(initialDate.value),
    }),
  ],
}
const InfoData = ref({
  dob_start: '',
  dob_end: '',
  email: '',
  personalTitle: '',
  personalContents: '',
  workPosition: '',
  workDepartment: '',
  workContents: '',
  management_no: '',
  address: '',
  additionalInformation1: '',
  additionalInformation2: '',
  additionalInformation3: '',
  additionalInformation4: '',
  additionalInformation5: '',
  institution: '',
  jobTypeParentId: '',
  jobTypeChildId: '',
  enrollmentStartPeriod: '',
  corporationEndPeriod: '',
  corporationStartPeriod: '',
  portfolioWorkHistoryCorporationName: '',
  historyJobTypeParentId: '',
  historyJobTypeChildId: '',
  startPeriod: '',
  endPeriod: '',
  corporationOrganizationName: '',
  corporationDepartmentName: '',
  searchMethods: SEARCH_METHODS.ALL,
  form_type: null,
})


const activeTab = ref(0)

const tabs = Object.keys(FORM_TYPE)
  .filter((key) => isNaN(Number(key)))
  .map((key, index) => ({
    label: translate(key),
    id: index,
  }))

const createDefaultData = () => ({
  corporationStartPeriod: '',
  corporationEndPeriod: '',
  corporationOrganizationName: '',
  corporationDepartmentName: '',
  additionalInformation1: '',
  additionalInformation2: '',
  additionalInformation3: '',
  additionalInformation4: '',
  additionalInformation5: '',
})

const additionalData = ref([createDefaultData(), createDefaultData(), createDefaultData()])

const searchMethods = [
  {
    label: translate('OE10includeAllForms'),
    value: SEARCH_METHODS.ALL,
  },
  {
    label: translate('OE10includeOnlyTheSelectedForm'),
    value: SEARCH_METHODS.ONE,
  },
]

const objChanged = async () => {
  const currentForm = additionalData.value[activeTab.value]
  await updateAdditionalData(currentForm)

  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'info', data: InfoData.value })
  const management_no_new = parseStringToArray(InfoData.value.management_no)
  nextTick(() => {
    emit('formDetail', { ...InfoData.value, management_no: management_no_new, form_type: getFormType(activeTab.value) })
  })
}

const getFormType = (index: number) => {
  return InfoData.value.searchMethods === SEARCH_METHODS.ONE ? data.value[index]?.form_type : null
}

const parseStringToArray = (value?: string | null): string[] => {
  if (!value) return []

  return value
    .replace(/\n/g, ',')
    .split(',')
    .map((str) => str.trim())
    .filter((str) => str.length > 0)
}

watch(
  () => InfoData.value?.jobTypeParentId,
  () => {
    InfoData.value.jobTypeChildId = ''
  },
  { immediate: true }
)

watch(
  () => InfoData.value?.historyJobTypeParentId,
  () => {
    InfoData.value.historyJobTypeChildId = ''
  },
  { immediate: true }
)

const route = useRoute()
const data = computed(() => store.getters[ALUMNI_REGISTER_FORM_STORE.GETTERS.ENTRY_FORM])

onMounted(async () => {
  try {
    await store.dispatch(ALUMNI_REGISTER_FORM_STORE.ACTIONS.SET_ENTRY_FORM, route?.params?.id)
  } catch (error) {
    console.log(error)
  }
})

watch(activeTab, async (newTab) => {
  const currentForm = additionalData.value[newTab]

  await updateInfoData(currentForm)
})

const updateInfoData = async (currentForm: any) => {
  if (!currentForm) return

  InfoData.value[`corporationStartPeriod`] = currentForm[`corporationStartPeriod`] || ''
  InfoData.value[`corporationEndPeriod`] = currentForm[`corporationEndPeriod`] || ''
  InfoData.value[`corporationOrganizationName`] = currentForm[`corporationOrganizationName`] || ''
  InfoData.value[`corporationDepartmentName`] = currentForm[`corporationDepartmentName`] || ''

  for (let i = 1; i <= MAX_ADDITIONAL_INFORMATION_LENGTH; i++) {
    InfoData.value[`additionalInformation${i}`] = currentForm[`additionalInformation${i}`] || ''
  }

  InfoData.value[`form_type`] = getFormType(activeTab.value)

  nextTick(() => {
    emit('formDetail', { ...InfoData.value, form_type: getFormType(activeTab.value) })
  })
}

const updateAdditionalData = async (currentForm: any) => {
  if (!currentForm) return

  nextTick(() => {
    currentForm[`corporationStartPeriod`] = InfoData.value?.corporationStartPeriod
    currentForm[`corporationEndPeriod`] = InfoData.value[`corporationEndPeriod`] || ''
    currentForm[`corporationOrganizationName`] = InfoData.value[`corporationOrganizationName`] || ''
    currentForm[`corporationDepartmentName`] = InfoData.value[`corporationDepartmentName`] || ''

    for (let i = 1; i <= MAX_ADDITIONAL_INFORMATION_LENGTH; i++) {
      currentForm[`additionalInformation${i}`] = InfoData.value[`additionalInformation${i}`] || ''
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitInfo && _ctx.submitInfo(...args)), ["prevent"])),
    class: "row align-items-center"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)(`OE10infoSearch`)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('managementNo')), 1),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("textarea", {
                  rows: "2",
                  class: "form-control fs-7",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((InfoData.value.management_no) = $event)),
                  placeholder: _unref(translate)('OE10placeholderTextareaAlumni'),
                  maxlength: _unref(MAX_LENGTH_USER_ID_LIST_SEARCH),
                  onChange: objChanged
                }, null, 40, _hoisted_10), [
                  [_vModelText, InfoData.value.management_no]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(flatPickr), {
                      modelValue: InfoData.value.dob_start,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((InfoData.value.dob_start) = $event)),
                      placeholder: "2000/01/01",
                      config: configDateSearch,
                      class: "form-control bg-white",
                      onChange: objChanged
                    }, null, 8, ["modelValue"]),
                    _hoisted_16
                  ])
                ]),
                _hoisted_17,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(flatPickr), {
                      modelValue: InfoData.value.dob_end,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((InfoData.value.dob_end) = $event)),
                      placeholder: "2000/01/01",
                      config: configDateSearch,
                      class: "form-control bg-white",
                      onChange: objChanged
                    }, null, 8, ["modelValue"]),
                    _hoisted_19
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(translate)(`email`)), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "inputEmail",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((InfoData.value.email) = $event)),
                    placeholder: _unref(translate)('placeholder'),
                    maxlength: _unref(MAX_LENGTH_EMAIL),
                    class: "form-control fs-7",
                    onChange: objChanged
                  }, null, 40, _hoisted_25), [
                    [
                      _vModelText,
                      InfoData.value.email,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ])
            ])
          ]),
          (__props.filterForAlumni)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(translate)('address')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select fs-7 w-max-content",
                        "aria-label": "Default select example",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((InfoData.value.address) = $event)),
                        onChange: objChanged
                      }, [
                        _createElementVNode("option", _hoisted_31, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PREFECTURES), (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.name), 9, _hoisted_32))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, InfoData.value.address]
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.filterForAlumni)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(translate)(`SA20currentJob`)), 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)(`SA20affiliation`)), 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((InfoData.value.institution) = $event)),
                              placeholder: _unref(translate)(`placeholder`),
                              class: "form-control fs-7",
                              onChange: objChanged
                            }, null, 40, _hoisted_42), [
                              [
                                _vModelText,
                                InfoData.value.institution,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(translate)(`SA20job`)), 1),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("label", _hoisted_47, _toDisplayString(_unref(translate)('SA20mainJob')), 1),
                          _createElementVNode("div", _hoisted_48, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select fs-7 w-max-content",
                              "aria-label": "Default select example",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((InfoData.value.jobTypeParentId) = $event)),
                              onChange: objChanged
                            }, [
                              _createElementVNode("option", _hoisted_49, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listJobs), (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: item.id
                                }, _toDisplayString(item.name), 9, _hoisted_50))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, InfoData.value.jobTypeParentId]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)('SA20subJob')), 1),
                          _createElementVNode("div", _hoisted_53, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select fs-7 w-max-content",
                              "aria-label": "Default select example",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((InfoData.value.jobTypeChildId) = $event)),
                              onChange: objChanged
                            }, [
                              _createElementVNode("option", _hoisted_54, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subJob.value, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: item.id
                                }, _toDisplayString(item.name), 9, _hoisted_55))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, InfoData.value.jobTypeChildId]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(translate)(`affiliationPeriod`)), 1),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createVNode(_unref(flatPickr), {
                                modelValue: InfoData.value.enrollmentStartPeriod,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((InfoData.value.enrollmentStartPeriod) = $event)),
                                placeholder: "2000/01",
                                config: _unref(configYM)(InfoData.value.enrollmentStartPeriod),
                                class: "form-control bg-white",
                                onChange: objChanged
                              }, null, 8, ["modelValue", "config"]),
                              _hoisted_62
                            ])
                          ]),
                          _createElementVNode("div", null, _toDisplayString(_unref(translate)('SA20dateNow')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("label", _hoisted_65, _toDisplayString(_unref(translate)(`OE10personalAlumni`)), 1),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_unref(translate)('title')), 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _withDirectives(_createElementVNode("input", {
                          type: "portfolioTitle",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((InfoData.value.personalTitle) = $event)),
                          placeholder: _unref(translate)('placeholder'),
                          maxlength: _unref(MAX_LENGTH_PERSONAL_TITLE_SEARCH),
                          class: "form-control fs-7",
                          onChange: objChanged
                        }, null, 40, _hoisted_72), [
                          [
                            _vModelText,
                            InfoData.value.personalTitle,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_73, _toDisplayString(_unref(translate)('OE10contents')), 1),
                      _createElementVNode("div", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                          type: "portfolioContents",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((InfoData.value.personalContents) = $event)),
                          placeholder: _unref(translate)('placeholder'),
                          maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
                          class: "form-control fs-7",
                          onChange: objChanged
                        }, null, 40, _hoisted_75), [
                          [
                            _vModelText,
                            InfoData.value.personalContents,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (__props.filterForAlumni)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("h2", _hoisted_78, [
                  _createElementVNode("button", {
                    class: _normalizeClass(['accordion-button fs-7 collapsed']),
                    type: "button",
                    name: "accordion",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#${_unref(translate)('OE10workHistoryAlumni')}`,
                    "aria-expanded": "true",
                    "aria-controls": _unref(translate)('OE10workHistoryAlumni')
                  }, _toDisplayString(_unref(translate)('OE10workHistoryAlumni')), 9, _hoisted_79)
                ]),
                _createElementVNode("div", {
                  id: _unref(translate)('OE10workHistoryAlumni'),
                  class: _normalizeClass(['accordion-collapse collapse']),
                  "aria-labelledby": "flush-headingOne",
                  "data-bs-parent": "#accordionFlushExample"
                }, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("label", _hoisted_86, _toDisplayString(_unref(translate)('SA20affiliation')), 1),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", _hoisted_89, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "jobTitle",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((InfoData.value.portfolioWorkHistoryCorporationName) = $event)),
                                  placeholder: _unref(translate)('placeholder'),
                                  maxlength: _unref(MAX_LENGTH_WORK_POSITION_SEARCH),
                                  class: "form-control fs-7",
                                  onChange: objChanged
                                }, null, 40, _hoisted_90), [
                                  [
                                    _vModelText,
                                    InfoData.value.portfolioWorkHistoryCorporationName,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(translate)('department')), 1),
                              _createElementVNode("div", _hoisted_92, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "department",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((InfoData.value.workDepartment) = $event)),
                                  placeholder: _unref(translate)('placeholder'),
                                  maxlength: _unref(MAX_LENGTH_WORK_DEPARTMENT_SEARCH),
                                  class: "form-control fs-7",
                                  onChange: objChanged
                                }, null, 40, _hoisted_93), [
                                  [
                                    _vModelText,
                                    InfoData.value.workDepartment,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _hoisted_96,
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("label", _hoisted_99, _toDisplayString(_unref(translate)('SA20job')), 1),
                          _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("label", _hoisted_102, _toDisplayString(_unref(translate)('SA20mainJob')), 1),
                              _createElementVNode("div", _hoisted_103, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select fs-7 w-max-content",
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((InfoData.value.historyJobTypeParentId) = $event)),
                                  onChange: objChanged
                                }, [
                                  _createElementVNode("option", _hoisted_104, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyListJobs), (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.id,
                                      key: item.id
                                    }, _toDisplayString(item.name), 9, _hoisted_105))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, InfoData.value.historyJobTypeParentId]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("label", _hoisted_107, _toDisplayString(_unref(translate)('SA20subJob')), 1),
                              _createElementVNode("div", _hoisted_108, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select fs-7 w-max-content",
                                  "aria-label": "Default select example",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((InfoData.value.historyJobTypeChildId) = $event)),
                                  onChange: objChanged
                                }, [
                                  _createElementVNode("option", _hoisted_109, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historySubJob.value, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.id,
                                      key: item.id
                                    }, _toDisplayString(item.name), 9, _hoisted_110))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, InfoData.value.historyJobTypeChildId]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _hoisted_113,
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, _toDisplayString(_unref(translate)('OE10jobTitle')), 1),
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("div", _hoisted_119, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "personalContent",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((InfoData.value.workPosition) = $event)),
                                  placeholder: _unref(translate)('placeholder'),
                                  maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
                                  class: "form-control fs-7",
                                  onChange: objChanged
                                }, null, 40, _hoisted_120), [
                                  [
                                    _vModelText,
                                    InfoData.value.workPosition,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _hoisted_123,
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("label", _hoisted_126, _toDisplayString(_unref(translate)('SA20enrollmentPeriod')), 1),
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createElementVNode("div", _hoisted_131, [
                                    _createVNode(_unref(flatPickr), {
                                      modelValue: InfoData.value.startPeriod,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((InfoData.value.startPeriod) = $event)),
                                      placeholder: "2000/01",
                                      config: _unref(configYM)(InfoData.value.startPeriod),
                                      class: "form-control bg-white",
                                      onChange: objChanged
                                    }, null, 8, ["modelValue", "config"]),
                                    _hoisted_132
                                  ]),
                                  _hoisted_133,
                                  _createElementVNode("div", _hoisted_134, [
                                    _createVNode(_unref(flatPickr), {
                                      modelValue: InfoData.value.endPeriod,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((InfoData.value.endPeriod) = $event)),
                                      placeholder: "2000/01",
                                      config: _unref(configYM)(InfoData.value.endPeriod),
                                      class: "form-control bg-white",
                                      onChange: objChanged
                                    }, null, 8, ["modelValue", "config"]),
                                    _hoisted_135
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _hoisted_138,
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, _toDisplayString(_unref(translate)('OE10contents')), 1),
                          _createElementVNode("div", _hoisted_142, [
                            _createElementVNode("div", _hoisted_143, [
                              _createElementVNode("div", _hoisted_144, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "personalContent",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((InfoData.value.workContents) = $event)),
                                  placeholder: _unref(translate)('placeholder'),
                                  maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
                                  class: "form-control fs-7",
                                  onChange: objChanged
                                }, null, 40, _hoisted_145), [
                                  [
                                    _vModelText,
                                    InfoData.value.workContents,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 8, _hoisted_80)
              ])
            ]))
          : _createCommentVNode("", true),
        (!__props.filterForAlumni)
          ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("label", _hoisted_148, _toDisplayString(_unref(translate)('OE10workHistoryAlumni')), 1),
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("label", _hoisted_151, _toDisplayString(_unref(translate)('OE10jobTitle')), 1),
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("div", _hoisted_153, [
                        _createElementVNode("div", _hoisted_154, [
                          _withDirectives(_createElementVNode("input", {
                            type: "jobTitle",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((InfoData.value.workPosition) = $event)),
                            placeholder: _unref(translate)('placeholder'),
                            maxlength: _unref(MAX_LENGTH_WORK_POSITION_SEARCH),
                            class: "form-control fs-7",
                            onChange: objChanged
                          }, null, 40, _hoisted_155), [
                            [
                              _vModelText,
                              InfoData.value.workPosition,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_156, _toDisplayString(_unref(translate)('department')), 1),
                        _createElementVNode("div", _hoisted_157, [
                          _withDirectives(_createElementVNode("input", {
                            type: "department",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((InfoData.value.workDepartment) = $event)),
                            placeholder: _unref(translate)('placeholder'),
                            maxlength: _unref(MAX_LENGTH_WORK_DEPARTMENT_SEARCH),
                            class: "form-control fs-7",
                            onChange: objChanged
                          }, null, 40, _hoisted_158), [
                            [
                              _vModelText,
                              InfoData.value.workDepartment,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!__props.filterForAlumni)
          ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
              _createElementVNode("div", _hoisted_160, [
                _hoisted_161,
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("div", _hoisted_163, [
                    _createElementVNode("div", _hoisted_164, _toDisplayString(_unref(translate)('OE10contents')), 1),
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("div", _hoisted_167, [
                          _withDirectives(_createElementVNode("input", {
                            type: "personalContent",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((InfoData.value.workContents) = $event)),
                            placeholder: _unref(translate)('placeholder'),
                            maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
                            class: "form-control fs-7",
                            onChange: objChanged
                          }, null, 40, _hoisted_168), [
                            [
                              _vModelText,
                              InfoData.value.workContents,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.filterForAlumni)
          ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("h2", _hoisted_171, [
                  _createElementVNode("button", {
                    class: _normalizeClass(['accordion-button fs-7 collapsed']),
                    type: "button",
                    name: "accordion",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#${_unref(translate)('SA20additionalInformation')}`,
                    "aria-expanded": "true",
                    "aria-controls": _unref(translate)('SA20additionalInformation')
                  }, _toDisplayString(_unref(translate)('SA20additionalInformation')), 9, _hoisted_172)
                ]),
                _createElementVNode("div", {
                  id: _unref(translate)('SA20additionalInformation'),
                  class: _normalizeClass(['accordion-collapse collapse']),
                  "aria-labelledby": "flush-headingOne",
                  "data-bs-parent": "#accordionFlushExample1"
                }, [
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_174, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: tab.label,
                            onClick: ($event: any) => (activeTab.value = tab.id),
                            class: _normalizeClass([activeTab.value === tab.id ? 'active' : '', 'fw-bold position-relative text-lg-start text-center'])
                          }, [
                            _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                            _hoisted_176
                          ], 10, _hoisted_175))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                        _createElementVNode("div", _hoisted_178, [
                          _hoisted_179,
                          _createElementVNode("div", _hoisted_180, [
                            _createElementVNode("div", _hoisted_181, [
                              _createElementVNode("div", _hoisted_182, _toDisplayString(_unref(translate)('OE10corporationOrganizationName')), 1),
                              _createElementVNode("div", _hoisted_183, [
                                _createElementVNode("div", _hoisted_184, [
                                  _createElementVNode("div", _hoisted_185, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((InfoData.value.corporationOrganizationName) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_186), [
                                      [
                                        _vModelText,
                                        InfoData.value.corporationOrganizationName,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                        _createElementVNode("div", _hoisted_188, [
                          _hoisted_189,
                          _createElementVNode("div", _hoisted_190, [
                            _createElementVNode("div", _hoisted_191, [
                              _createElementVNode("div", _hoisted_192, _toDisplayString(_unref(translate)('SA20department')), 1),
                              _createElementVNode("div", _hoisted_193, [
                                _createElementVNode("div", _hoisted_194, [
                                  _createElementVNode("div", _hoisted_195, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((InfoData.value.corporationDepartmentName) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_196), [
                                      [
                                        _vModelText,
                                        InfoData.value.corporationDepartmentName,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                        _createElementVNode("div", _hoisted_198, [
                          _hoisted_199,
                          _createElementVNode("div", _hoisted_200, [
                            _createElementVNode("div", _hoisted_201, [
                              _createElementVNode("div", _hoisted_202, _toDisplayString(_unref(translate)('SA20enrollmentPeriod')), 1),
                              _createElementVNode("div", _hoisted_203, [
                                _createElementVNode("div", _hoisted_204, [
                                  _createElementVNode("div", _hoisted_205, [
                                    _createElementVNode("div", _hoisted_206, [
                                      _createElementVNode("div", _hoisted_207, [
                                        _createVNode(_unref(flatPickr), {
                                          modelValue: InfoData.value.corporationStartPeriod,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((InfoData.value.corporationStartPeriod) = $event)),
                                          placeholder: "2000/01",
                                          config: _unref(configYM)(InfoData.value.corporationStartPeriod),
                                          class: "form-control bg-white",
                                          onChange: objChanged
                                        }, null, 8, ["modelValue", "config"]),
                                        _hoisted_208
                                      ]),
                                      _hoisted_209,
                                      _createElementVNode("div", _hoisted_210, [
                                        _createVNode(_unref(flatPickr), {
                                          modelValue: InfoData.value.corporationEndPeriod,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((InfoData.value.corporationEndPeriod) = $event)),
                                          placeholder: "2000/01",
                                          config: _unref(configYM)(InfoData.value.corporationEndPeriod),
                                          class: "form-control bg-white",
                                          onChange: objChanged
                                        }, null, 8, ["modelValue", "config"]),
                                        _hoisted_211
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                        _createElementVNode("div", _hoisted_213, [
                          _hoisted_214,
                          _createElementVNode("div", _hoisted_215, [
                            _createElementVNode("div", _hoisted_216, [
                              _createElementVNode("div", _hoisted_217, _toDisplayString(_unref(data)[activeTab.value]?.additional_information_1_question || _unref(translate)('additionalInformation1Question')), 1),
                              _createElementVNode("div", _hoisted_218, [
                                _createElementVNode("div", _hoisted_219, [
                                  _createElementVNode("div", _hoisted_220, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((InfoData.value.additionalInformation1) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_221), [
                                      [
                                        _vModelText,
                                        InfoData.value.additionalInformation1,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                        _createElementVNode("div", _hoisted_223, [
                          _hoisted_224,
                          _createElementVNode("div", _hoisted_225, [
                            _createElementVNode("div", _hoisted_226, [
                              _createElementVNode("div", _hoisted_227, _toDisplayString(_unref(data)[activeTab.value]?.additional_information_2_question || _unref(translate)('additionalInformation2Question')), 1),
                              _createElementVNode("div", _hoisted_228, [
                                _createElementVNode("div", _hoisted_229, [
                                  _createElementVNode("div", _hoisted_230, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((InfoData.value.additionalInformation2) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_231), [
                                      [
                                        _vModelText,
                                        InfoData.value.additionalInformation2,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                        _createElementVNode("div", _hoisted_233, [
                          _hoisted_234,
                          _createElementVNode("div", _hoisted_235, [
                            _createElementVNode("div", _hoisted_236, [
                              _createElementVNode("div", _hoisted_237, _toDisplayString(_unref(data)[activeTab.value]?.additional_information_3_question || _unref(translate)('additionalInformation3Question')), 1),
                              _createElementVNode("div", _hoisted_238, [
                                _createElementVNode("div", _hoisted_239, [
                                  _createElementVNode("div", _hoisted_240, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((InfoData.value.additionalInformation3) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_241), [
                                      [
                                        _vModelText,
                                        InfoData.value.additionalInformation3,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                        _createElementVNode("div", _hoisted_243, [
                          _hoisted_244,
                          _createElementVNode("div", _hoisted_245, [
                            _createElementVNode("div", _hoisted_246, [
                              _createElementVNode("div", _hoisted_247, _toDisplayString(_unref(data)[activeTab.value]?.additional_information_4_question || _unref(translate)('additionalInformation4Question')), 1),
                              _createElementVNode("div", _hoisted_248, [
                                _createElementVNode("div", _hoisted_249, [
                                  _createElementVNode("div", _hoisted_250, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((InfoData.value.additionalInformation4) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_251), [
                                      [
                                        _vModelText,
                                        InfoData.value.additionalInformation4,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.filterForAlumni)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                        _createElementVNode("div", _hoisted_253, [
                          _hoisted_254,
                          _createElementVNode("div", _hoisted_255, [
                            _createElementVNode("div", _hoisted_256, [
                              _createElementVNode("div", _hoisted_257, _toDisplayString(_unref(data)[activeTab.value]?.additional_information_5_question || _unref(translate)('additionalInformation5Question')), 1),
                              _createElementVNode("div", _hoisted_258, [
                                _createElementVNode("div", _hoisted_259, [
                                  _createElementVNode("div", _hoisted_260, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((InfoData.value.additionalInformation5) = $event)),
                                      placeholder: _unref(translate)('placeholder'),
                                      maxlength: _unref(MAX_LENGTH_ADDITIONAL_INFORMATION),
                                      class: "form-control fs-7",
                                      onChange: objChanged
                                    }, null, 40, _hoisted_261), [
                                      [
                                        _vModelText,
                                        InfoData.value.additionalInformation5,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_262, [
                    _createElementVNode("div", _hoisted_263, [
                      _hoisted_264,
                      _createElementVNode("div", _hoisted_265, [
                        _createElementVNode("div", _hoisted_266, [
                          _createElementVNode("div", _hoisted_267, _toDisplayString(_unref(translate)('OE10searchMethods')), 1),
                          _createElementVNode("div", _hoisted_268, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(searchMethods, (item, index) => {
                              return _createElementVNode("div", {
                                class: "row",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_269, [
                                  _createElementVNode("div", _hoisted_270, [
                                    _createElementVNode("label", {
                                      class: "form-check-label fs-7 text-nowrap cursor-pointer",
                                      for: 'searchMethods_' + item.value
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((InfoData.value.searchMethods) = $event)),
                                        type: "radio",
                                        id: 'searchMethods_' + item.value,
                                        value: item.value,
                                        onChange: objChanged
                                      }, null, 40, _hoisted_272), [
                                        [_vModelRadio, InfoData.value.searchMethods]
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(item.label), 1)
                                    ], 8, _hoisted_271)
                                  ])
                                ])
                              ])
                            }), 64))
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 8, _hoisted_173)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 32))
}
}

})